import { Injectable } from '@angular/core';
import { TranslationService } from '../../domain/translation';

@Injectable({ providedIn: 'root' })
export class PublicTranslationService extends TranslationService {
  protected endpoint = 'translation';
}
